module.exports = __webpack_public_path__ + "img/9b1ab9f0573c1ab5bf2d7ec09d5e38a7.png";